import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { IInvoice } from '../../interfaces';
import { setGlobalState } from '../../state';

const useGetInvoice = (invoice_id: string | undefined) => {
    const [fetchedInvoice, setFetchedInvoice] = useState(false);
    const [invoice, setInvoice] = useState<IInvoice>();

    const fetchInvoice = useCallback(async () => {
        if (!invoice_id) return;
        setFetchedInvoice(false);
        setInvoice(undefined);
        axios
            .get(import.meta.env.VITE_API_BASE_URL + 'web/invoice/' + invoice_id + '/')
            .then((res) => {
                setFetchedInvoice(true);
                setInvoice(res.data);
                setGlobalState('invoice', res.data);
                setGlobalState('checkoutLocked', false);
                setGlobalState('optionStatus', '');
            })
            .catch((err) => {
                console.error('Error fetching invoice:', err);
                setFetchedInvoice(true);
            });
    }, [invoice_id]);

    useEffect(() => {
        fetchInvoice();
    }, [fetchInvoice]);

    return { invoice, fetchedInvoice };
};

export default useGetInvoice;
